<template>
  <ModalDialog
    ref="dialog"
    title="Edit References"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-pencil"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Confirmation Reference Number" v-if="isStatusCompleted(PurchaseOrderStatusTypes.pendingShipping)">
        <FormInputText v-model="supplierConfirmRef" field="supplierConfirmRef" />
      </FormRow>
      <FormRow label="Shipping Container Reference" v-if="isStatusCompleted(PurchaseOrderStatusTypes.pendingReceival)">
        <FormInputText v-model="supplierShipContainerRef" field="supplierShipContainerRef" />
      </FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { PurchaseOrderStatusTypes } from '@/store/types'

export default {
  name: 'EditPurchaseOrderReferenceDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    purchaseOrderId: Number,
  },
  watch: {
    
  },
  data() {
    return {
      dialogForm: {},
      submitting: false,
      status: '',
      supplierConfirmRef: '',
      supplierShipContainerRef: ''
    }
  },
  created() {
    this.PurchaseOrderStatusTypes = PurchaseOrderStatusTypes
  },
  computed: {
  },
  methods: {
    show(purchaseOrder = {}) {

      this.status = purchaseOrder.status
      this.supplierConfirmRef = purchaseOrder.supplierConfirmRef
      this.supplierShipContainerRef = purchaseOrder.supplierShipContainerRef

      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      let updateData = {}

      if(this.isStatusCompleted(PurchaseOrderStatusTypes.pendingShipping))
        updateData.supplierConfirmRef = this.supplierConfirmRef
      if(this.isStatusCompleted(PurchaseOrderStatusTypes.pendingReceival))
        updateData.supplierShipContainerRef = this.supplierShipContainerRef

      this.$apiService.purchasingService.updatePurchaseOrderReferences(this.purchaseOrderId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    isStatusCompleted(status) {
      // Must be in order
      let statusList = [
        PurchaseOrderStatusTypes.pendingApproval,
        PurchaseOrderStatusTypes.pendingConfirmation,   // Bulk Only
        PurchaseOrderStatusTypes.pendingShipping,       // Bulk Only
        PurchaseOrderStatusTypes.pendingReceival,
        PurchaseOrderStatusTypes.receiving,
        PurchaseOrderStatusTypes.completed,
        PurchaseOrderStatusTypes.cancelled
      ]

      return statusList.indexOf(this.status) >= statusList.indexOf(status)
    },
  }
}
</script>